import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";

export default class V1UserGuestLogin extends BaseOutgoingPayload {
  public readonly payload: V1UserGuestLoginPayload;

  constructor(name: string) {
    super(OutgoingPayloadEvent.V1_USER_GUEST_LOGIN);
    this.payload = new V1UserGuestLoginPayload(name);
  }
}

class V1UserGuestLoginPayload {
  public readonly name: string;

  constructor(name: string) {
    this.name = name;
  }
}
